function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEdit = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M11.1566 5.68682H5.59035C5.16857 5.68682 4.76405 5.85438 4.4658 6.15263C4.16755 6.45088 4 6.85539 4 7.27718V18.4096C4 18.8314 4.16755 19.2359 4.4658 19.5342C4.76405 19.8324 5.16857 20 5.59035 20H16.7228C17.1446 20 17.5491 19.8324 17.8474 19.5342C18.1456 19.2359 18.3132 18.8314 18.3132 18.4096V12.8434M17.1204 4.49406C17.4368 4.17772 17.8658 4 18.3132 4C18.7605 4 19.1896 4.17772 19.5059 4.49406C19.8223 4.8104 20 5.23945 20 5.68682C20 6.1342 19.8223 6.56325 19.5059 6.87959L11.9518 14.4338L8.77106 15.2289L9.56624 12.0482L17.1204 4.49406Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  style: {
    fillOpacity: 0
  }
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-edit.b09e19667810c9afbce341fdca5feb2f.svg";